import { CSAT_ABM } from 'ui-forms-components/constants/FeedbackSurveys';
import { getFeedbackSurveyForEnviro } from 'FormsUI/utils/FeedbackSurveys';
import { STEPS } from 'FormsUI/constants/NavigationSteps';
const getFeedbackSurveyIdObject = () => CSAT_ABM;
export const getFeedbackSurveyId = () => {
  const FEEDBACK_SURVEY = getFeedbackSurveyIdObject();
  return getFeedbackSurveyForEnviro(FEEDBACK_SURVEY);
};
export const getDisplayEditorFeedbackSurvey = step => step !== STEPS.AUTOMATION;